export default {
  account: 'Manage account',
  adminComment: 'Comment for User',
  adminCommentInternal: 'Comment for other Administrative Users',
  adminResponseInfo: 'Administrator reply',
  advancedStaffSearch: 'Advanced Staff search',
  approve: 'Approve',
  approved: 'Approved',
  back: 'Previous',
  basicInfo: 'Basic information',
  birthDate: 'Date of birth',
  birthDay: 'DD',
  birthMonth: 'MM',
  birthYear: 'YYYY',
  cardFilter: 'Card',
  cardID: 'Αριθμός κάρτας',
  cardOptions: {
    na: 'With or without card',
    any: 'Any card',
    one: 'Specific card number'
  },
  certifiedUpdated: 'Your information from IDIKA has changed (from %{date})',
  change: 'Change',
  citizenship: 'Υπηκοότητα',
  close: 'Close',
  comments: 'Comments (Optional)',
  confirm: {
    mail: 'Please enter the PIN you received via email',
    phone: 'Please enter the PIN you received via mobile phone',
    ssn: 'Please enter your AMKA',
    title: 'Confirmation'
  },
  contactInfo: 'Contact details',
  contractType: 'Type of access',
  copyright: '© 2017 National Library of Greece. All rights reserved.',
  countrySsn: 'Χώρα ΑΜΚΑ',
  countryTin: 'Χώρα ΑΦΜ',
  data: 'Information',
  dataChanged: 'Your data has been updated',
  date: 'Date',
  dateRange: {
    from: 'From',
    to: 'To'
  },
  deactivation: 'Request to deactivate',
  desc:
    'Account Management allows users to request roles, view previously made requests, and manage passwords',
  editManual: 'Επεξεργασία στοιχείων χειροκίνητα',
  error: {
    desc: 'Please contact the website administrator',
    existingTin:
      'A Registered User with Tax ID number: %{tin} and Account %{contact} already exists',
    generic: 'We apologise, there was a problem!',
    gsis: 'We apologise, there was a problem with TAXISnet!',
    ssnExists: 'A user with that ssn already exists',
    ssnDoesNotExist: 'Ssn does not exist in public ssn records',
    valueExists: 'Value provided already belongs to a user',
    ssnTinMismatch: 'AMKA and VAT number do not match'
  },
  errorCode: 'Error code',
  faq: 'Frequently Asked Questions',
  fathername: "Father's name",
  firstname: 'Name',
  forceRole: 'Add roles to user',
  formData: 'Δεδομένα φόρμας',
  gender: {
    gender: 'Φύλο',
    male: 'Άνδρας',
    female: 'Γυναίκα',
    other: 'Άλλο'
  },
  gsisLogin: 'Login to TAXISnet',
  gsisLogout: 'Disconnect from TAXISnet',
  gsisLogoutDesc:
    'If you wish to sign in with a different TAXISnet account, you must log out and repeat the upgrade process',
  hasGreekTinWarning:
    'Προσοχή! Ο χρήστης φαίνεται να έχει ελληνικό ΑΦΜ στο εθνικό μητρώο ΑΜΚΑ',
  helpdeskComment: 'Helpdesk note',
  hideRoles: 'Hide user roles',
  idCountry: 'Country of ID issue',
  idDateIssued: 'Ημερομηνία έκδοσης',
  idDoc: 'Identification document',
  identityInfo: 'Πληροφορίες ταυτότητας',
  idikaConflict: 'Σύγκρουση δεδομένων φόρμας με ΗΔΙΚΑ',
  idikaData: 'Δεδομένα από την ΗΔΙΚΑ',
  idFilter: {
    all: 'None',
    birthPaper: 'Ληξιαρχική πράξη γέννησης',
    id: 'National ID',
    militaryId: 'Military ID',
    passport: 'Passport'
  },
  idNumber: 'ID number',
  idikaUpdate: 'Update information from IDIKA',
  info: 'Useful information',
  internalPhone: 'Εσωτερικό τηλέφωνο',
  lang: {
    el: 'Greek - EL',
    en: 'English – EN'
  },
  lastname: 'Surname',
  login: 'Login',
  logoTitle: 'Go to Account Management homepage',
  logout: 'Exit',
  mail: 'Email',
  notice: 'Notice',
  notificationSeen: 'Notification received',
  noRolesAvailable: 'There are no available roles for your account',
  password: 'Manage passwords',
  pending: 'Pending',
  phone: 'Mobile phone',
  pin: 'PIN',
  position: 'Position',
  privacyPolicy: 'Personal data protection policy',
  profile: 'View Profile',
  registration: 'Registration',
  reject: 'Reject',
  rejected: 'Rejected',
  request: 'Activation request',
  requestAdd: 'Request activation',
  requestRemove: 'Request deactivation',
  requestStatus: 'Request status',
  requestType: 'Request type',
  requestedRole: 'Requested role',
  requests: 'Requests',
  requestsFilter: {
    all: 'All requests',
    approved: 'Approved requests',
    completed: 'Completed requests',
    forced: 'Roles added by the administrator',
    pending: 'Pending requests',
    rejected: 'Rejected requests'
  },
  respond: 'Manage requests',
  response: 'Reply to request',
  resultsFound: '%{number} results found',
  resultsShown: '%{number} results displayed',
  reviewer: 'Administrator name',
  role: 'Role',
  roleAdd: 'Προσθήκη ρόλου',
  roleRemove: 'Αφαίρεση ρόλου',
  roles: 'Roles',
  rolesAll: 'All roles',
  search: 'Search',
  secondaryDataNote:
    'The contact info used for password recovery has not been changed. If you wish to change it visit',
  selectCountry: 'Επιλογή χώρας',
  selectRole: 'Select role',
  showRequests: 'User requests',
  showRoles: 'User roles',
  ssn: 'AMKA',
  submit: 'Submit changes',
  submitRequest: 'Complete request',
  subtitle: {
    data: 'Manage information',
    requests: 'Manage requests',
    roles: 'Manage roles'
  },
  tin: 'Tax ID Number',
  title: 'National Library of Greece',
  type: 'User type',
  typeFilter: {
    all: 'All user types',
    certified: 'Registered User',
    staff: 'Staff',
    user: 'Simple User',
    helpdesk: 'Helpdesk certified'
  },
  upgrade: {
    approved: 'Εγκρίθηκε',
    modified: 'Τροποποιήθηκε',
    pradoMismatch:
      'Τα δεδομένα εγγράφου ταυτοποίησης δεν συμφωνούν με την ΗΔΙΚΑ.',
    pradoOther:
      'Ο τύπος εγγράφου ταυτοποίησης που βρίσκεται ΗΔΙΚΑ δεν υποστηρίζεται.',
    pradoTypeMismatch:
      'Το έγγραφο ταυτοποίησης που δόθηκε για τον συγκεκριμένο ΑΜΚΑ (%{formDoc}) δεν συμφωνεί με αυτό της ΗΔΙΚΑ (%{idikaDoc}).',
    system: 'Σύστημα'
  },
  upgradeDesc:
    'Registered Users have access to all of the electronic services offered by the NLG. Authentication of User details (Name, Surname, Maiden Name, Date of Birth) requires connection to TAXISnet',
  upgradeManual: 'Αναβάθμιση σε Πιστοποιημένο χρήστη χειροκίνητα',
  upgradeUser: 'Upgrade to Registered User',
  usage: 'User instructions',
  userRequestInfo: 'User request',
  users: 'Manage Users',
  version: 'Version %{version}',
  versionBackend: '- %{version}',
  viewRequest: 'View request',
  warning: 'Attention'
}



// WEBPACK FOOTER //
// ./i18n/locale-en.js